var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":"onBlur","label-width":"150px"}},[_c('el-button',{attrs:{"type":"info","icon":"el-icon-edit","plain":"","round":""},on:{"click":function($event){return _vm.editEventHandler('onBlur', _vm.eventParams)}}},[_vm._v(" "+_vm._s(_vm.i18nt('designer.setting.addEventHandler')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }